import { Enum } from '../../common/constants'

export const MerchantApplicationSteps = {
  ConfirmInfo: 0,
  BusinessDetails: 1,
  BusinessOwners: 2,
  BankAccount: 3,
  Documents: 4,
} as const

export type MerchantApplicationStep = Enum<typeof MerchantApplicationSteps>

export const STEP_COUNT = 5

export const STEP_LABELS = [
  'Confirm Your Information',
  'Business Details',
  'Business Owners',
  'Bank Account',
  'Upload Documents',
]

export const OrganizationTypes = {
  SoleProprietor: 'sole_proprietor',
  LLC: 'llc',
  Corporation: 'corporation',
  Partnership: 'partnership',
  NonProfit: 'non_profit',
} as const

export type OrganizationType = Enum<typeof OrganizationTypes>

export const OrganizationTypeLabels: Record<OrganizationType, string> = {
  [OrganizationTypes.SoleProprietor]: 'Sole Proprietor',
  [OrganizationTypes.LLC]: 'LLC',
  [OrganizationTypes.Corporation]: 'Corporation',
  [OrganizationTypes.Partnership]: 'Partnership',
  [OrganizationTypes.NonProfit]: 'Non-Profit',
}

// Step 1: Confirm info
export type ConfirmInfoData = {
  firstName: string
  lastName: string
  email: string
  businessName: string
  businessDba: string
  phoneNumber: string
  website: string
  address1: string
  city: string
  stateCode: string
  zip: string
}

// Step 2: Business details
export type BusinessDetailsData = {
  taxId: string
  organizationType: OrganizationType | ''
  averagePaymentAmount: string
  maximumPaymentAmount: string
  monthlyPaymentTotal: string
}

// Step 3: Business owners
export type OwnerData = {
  id: string
  firstName: string
  lastName: string
  email: string
  phone: string
  dateOfBirth: string
  ssn: string
  ownershipPercentage: number
  useBusinessAddress: boolean
  address1: string
  city: string
  stateCode: string
  zip: string
}

// Step 4: Bank account
export type BankAccountData = {
  bankName: string
  routingNumber: string
  accountNumber: string
  confirmAccountNumber: string
}

// Step 5: Documents
export type DocumentUpload = {
  file: File | null
}

export type DocumentsData = {
  taxIdDocument: DocumentUpload
  identificationDocument: DocumentUpload
  bankDocument: DocumentUpload
}

// Pre-fill data returned by the dummy API
export type PreFillData = {
  firstName: string
  lastName: string
  email: string
  businessName: string
  phoneNumber: string
  website: string
  address1: string
  city: string
  stateCode: string
  zip: string
  paymentEstimates: {
    averagePayment: number | null
    maximumPayment: number | null
    monthlyTotal: number | null
  }
}

// Full application state
export type MerchantApplicationState = {
  currentStep: MerchantApplicationStep
  isLoading: boolean
  confirmInfo: ConfirmInfoData
  businessDetails: BusinessDetailsData
  owners: OwnerData[]
  bankAccount: BankAccountData
  documents: DocumentsData
  hasPaymentHistory: boolean
  isSubmitting: boolean
  isSubmitted: boolean
}
